<template>
  <div>
    <v-card flat>
      <v-card-text class="pt-0">
        <fieldset class="srs_fset">
          <legend class="srs_lgd">{{ $t('page.series.expansion-panel.series-results') }}</legend>
          <div></div>
          <div class="clearfix">
            <v-form class="filtersSeries">
              <v-row>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-autocomplete 
                    v-model="inputs.races" 
                    :items="itemsRaces"
                    :label="$t('page.series.table.race.label-select-race-creation')" 
                    ref="inputRaces" 
                    outlined dense
                    @change="getResults"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row no-gutters class="my-3">
                <v-col class="group-resp" cols="12">
                  <v-btn @click="refreshScores" class="mb-3 mr-2">{{ $t('page.series.refresh-scores') }}</v-btn>
                  <v-btn @click="createItem" class="mb-3 mr-2">{{
                    $t('page.series.add-participant') }}</v-btn>
                  <v-btn v-if="inputs.races && inputs.races > 0" @click="importScoresConfirm" class="mb-3 mr-2">{{
                    $t('page.series.import-scores') }}</v-btn>
                    <v-btn v-if="inputs.races && inputs.races > 0" @click="confirmDeleteScores" class="mb-3 mr-2">{{
                    $t('page.series.delete-scores') }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex groupSelectOthers" cols="12" sm="6">
                  <v-select :label="$t('page.race-scores.column-selection')" v-model="column" :items="column_items"
                    item-text="text" item-value="id" persistent-hint :multiple="true" :outlined="true"
                    @change="columnSelection()" dense
                    :no-data-text="$t('common.no_data')"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ column.length - 1 }} {{ $t("page.race-scores.others") }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
            <br />
            <VueTabulator ref="tabulator" v-model="listData" :options="tabulatorOptions" style="width: 100%" />
            <Modal v-if="isModalOpen" :title="titleModal" @close="isModalOpen = false">
              <v-card >
                <!-- <v-card-title>
                  <span class="headline" v-if="editorType == 'new'">{{ $t('page.series.add-participant') }}</span>
                  <span class="headline" v-else>{{ $t('page.series.edit-participant', {
                    firstName: inputs.form.firstName,
                    lastName: inputs.form.lastName
                  }) }}</span>
                  <v-icon class="ml-auto" @click="close">fa-times</v-icon>
                </v-card-title> -->
                <v-card-text>
                  <v-form ref="formEdit" class="formEdit">
                    <br />
                    <v-row>
                    <v-col class="d-flex" cols="12">
                      <v-select 
                        v-model="inputs.form.raceId" 
                        :items="itemsRaces"
                        :label="$tc('page.series.table.race.label-select-race-creation')" 
                        :rules="raceIdRules"
                        outlined dense
                      ></v-select>
                    </v-col>
                  </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete 
                          class="tt"
                          v-if="editorType == 'new'"
                          v-model="inputs.form.loadParticipant"
                          :items="participantsSeries"
                          :loading="isLoading"
                          :search-input.sync="search"
                          :filter="customFilter"
                          :label="$t('common.form.load_participant')"
                          @click="recoverLastSearchTerms"
                          @change="onParticipantSelected"
                          item-value="value"
                          item-text="text"
                          hide-no-data
                          hide-selected
                          outlined
                          maxlength="150"
                          dense
                          :no-data-text="$t('common.no_data')"
                        >

                          <template v-slot:item="data">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span v-html="paintMatchingTerms(data.item.text, search)"></span>
                              </v-list-item-title>
                              <v-list-item-title v-for="(membership, index) in data.item.additionalInfo" :key="index">
                                {{ membership.clubName }}, {{ membership.organizationClass }} - {{ membership.raceClass }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined dense
                          v-model="inputs.form.userId"
                          :label="$t('common.form.user-id')"
                          :rules="[
                            (v) => $inputRules({ value: v }, 'bigInteger') || $t('common.request.error-user-id-numeric')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined dense 
                          v-model="inputs.form.firstName"
                          :rules="[
                            (v) => $inputRules({value: v, minSize: 1, maxSize: 40}, 'fieldLength') || $t('page.race-scores.first-name-invalid')
                          ]"
                          :label="$t('common.form.first-name')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$t('common.form.last-name')" v-model="inputs.form.lastName"
                          :rules="[
                            (v) => $inputRules({value: v, minSize: 1, maxSize: 40}, 'fieldLength') || $t('page.race-scores.last-name-invalid')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select v-model="inputs.form.className" :items="classSeriesProcessed" item-value="className"
                          item-text="className" :label="$tc('common.form.class-name')" outlined dense return-object
                          :rules="classNameRules"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select v-model="inputs.form.groupName" :items="groupSeries" item-value="groupName"
                          item-text="groupName" :label="$t('common.form.group-name')" outlined dense
                          return-object
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$t('common.form.brand')"
                          v-model="inputs.form.brand"
                          :rules="[
                            (v) => $inputRules({value: v, minSize: 0, maxSize: 20}, 'fieldLength') || $t('page.race-scores.brand-invalid')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>                    
                    <v-row>
                      <v-col cols="12">
                        <v-select outlined dense
                          :label="$t('common.form.standing')" 
                          :items="standingItems" v-model="inputs.form.standing"
                          :rules=standingRules
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$tc('common.form.overall-position')"
                          v-model="inputs.form.overallPosition" 
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 25}, 'fieldLength') || $t('page.race-scores.overall-position-invalid')
                          ]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$tc('common.form.class-position')"
                          v-model="inputs.form.classPosition" 
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 25}, 'fieldLength') || $t('page.race-scores.class-position-invalid')
                          ]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$tc('common.form.group-position')"
                          v-model="inputs.form.groupPosition" 
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 25}, 'fieldLength') || $t('page.race-scores.group-position-invalid')
                          ]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense
                          v-model="inputs.form.positionLabel"
                          :label="$tc('common.form.position-label')"
                          :hint="$tc('page.race-scores.position-label-hint')"
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 55}, 'fieldLength') || $t('page.race-scores.position-label-invalid')
                          ]"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select v-if="listWorkerPoints.length > 0" outlined dense
                          :label="$tc('common.form.worker-points')" :items="listWorkerPoints"
                          v-model="inputs.form.workerPoints"></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-spacer></v-spacer>
                  </v-card-text>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="darken-1" dark small @click="close">{{ $tc('common.form.cancel') }}</v-btn>
                  <v-btn color="darken-1" dark small @click="save">{{ $tc('common.form.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </Modal>

            <v-dialog max-width="600px" persistent  class="dd-dialog" >
              <v-card >
                <v-card-title>
                  <span class="headline" v-if="editorType == 'new'">{{ $tc('page.series.add-participant') }}</span>
                  <span class="headline" v-else>{{ $t('page.series.edit-participant', {
                    firstName: inputs.form.firstName,
                    lastName: inputs.form.lastName
                  }) }}</span>
                  <v-icon class="ml-auto" @click="close">fa-times</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-form ref="formEdit" class="formEdit">
                    <br />
                    <v-row>
                    <v-col class="d-flex" cols="12">
                      <v-select 
                        v-model="inputs.form.raceId" 
                        :items="itemsRaces"
                        :label="$tc('page.series.table.race.label-select-race-creation')" 
                        :rules="raceIdRules"
                        outlined dense
                      ></v-select>
                    </v-col>
                  </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete 
                          class="tt"
                          v-if="editorType == 'new'"
                          v-model="inputs.form.loadParticipant"
                          :items="participantsSeries"
                          :loading="isLoading"
                          :search-input.sync="search"
                          :filter="customFilter"
                          :label="$t('common.form.load_participant')"
                          @click="recoverLastSearchTerms"
                          @change="onParticipantSelected"
                          item-value="value"
                          item-text="text"
                          hide-no-data
                          hide-selected
                          outlined
                          maxlength="150"
                          dense
                        >

                          <template v-slot:item="data">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span v-html="paintMatchingTerms(data.item.text, search)"></span>
                              </v-list-item-title>
                              <v-list-item-title v-for="(membership, index) in data.item.additionalInfo" :key="index">
                                {{ membership.clubName }}, {{ membership.organizationClass }} - {{ membership.raceClass }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined dense
                          v-model="inputs.form.userId"
                          :label="$tc('common.form.user-id')"
                          :rules="[
                            (v) => $inputRules({ value: v }, 'bigInteger') || $t('common.request.error-user-id-numeric')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined dense 
                          v-model="inputs.form.firstName"
                          :rules="[
                            (v) => $inputRules({value: v, minSize: 1, maxSize: 40}, 'fieldLength') || $tc('page.race-scores.first-name-invalid')
                          ]"
                          :label="$tc('common.form.first-name')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$tc('common.form.last-name')" v-model="inputs.form.lastName"
                          :rules="[
                            (v) => $inputRules({value: v, minSize: 1, maxSize: 40}, 'fieldLength') || $tc('page.race-scores.last-name-invalid')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select v-model="inputs.form.className" :items="classSeriesProcessed" item-value="className"
                          item-text="className" :label="$t('common.form.class-name')" outlined dense return-object
                          :rules="classNameRules"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select v-model="inputs.form.groupName" :items="groupSeries" item-value="groupName"
                          item-text="groupName" :label="$tc('common.form.group-name')" outlined dense
                          return-object></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$tc('common.form.brand')"
                          v-model="inputs.form.brand"
                          :rules="[
                            (v) => $inputRules({value: v, minSize: 0, maxSize: 20}, 'fieldLength') || $tc('page.race-scores.brand-invalid')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>                    
                    <v-row>
                      <v-col cols="12">
                        <v-select outlined dense
                          :label="$t('common.form.standing')" 
                          :items="standingItems" v-model="inputs.form.standing"
                          :rules=standingRules
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$t('common.form.overall-position')"
                          v-model="inputs.form.overallPosition" 
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 25}, 'fieldLength') || $t('page.race-scores.overall-position-invalid')
                          ]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$t('common.form.class-position')"
                          v-model="inputs.form.classPosition" 
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 25}, 'fieldLength') || $t('page.race-scores.class-position-invalid')
                          ]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$t('common.form.group-position')"
                          v-model="inputs.form.groupPosition" 
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 25}, 'fieldLength') || $t('page.race-scores.group-position-invalid')
                          ]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense
                          v-model="inputs.form.positionLabel"
                          :label="$t('common.form.position-label')"
                          :hint="$t('page.race-scores.position-label-hint')"
                          :rules="[
                            (value) => $inputRules({value, minSize: 0, maxSize: 55}, 'fieldLength') || $t('page.race-scores.position-label-invalid')
                          ]"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select v-if="listWorkerPoints.length > 0" outlined dense
                          :label="$t('common.form.worker-points')" :items="listWorkerPoints"
                          v-model="inputs.form.workerPoints"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-spacer></v-spacer>
                  </v-card-text>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="darken-1" dark small @click="close">{{ $t('common.form.cancel') }}</v-btn>
                  <v-btn color="darken-1" dark small @click="save">{{ $t('common.form.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </fieldset>
      </v-card-text>
    </v-card>

    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')"
      @cancel="dialogNotification = false;" @agree="deleteItem" type="warning" :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')" />
      <SGSNotificationConfirm v-if="dialogNotificationDeleteScores" :notificationMessage="$t('common.confirm-delete')"
      @cancel="dialogNotificationDeleteScores = false;" @agree="deleteScores" type="warning" :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')" />

    <SGSNotificationConfirm v-if="importNotification" :notificationMessage="$t('common.confirm-import')"
      @cancel="importNotification = false;" @agree="importScores" type="warning" :acept="$t('common.form.import')"
      :reject="$t('common.form.cancel')" />

    <SGSNotificationConfirm v-if="alertError" :notificationMessage="alertErrorMsg"
      @cancel="alertError = false;" type="error" :reject="$t('common.form.cancel')" />

    <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
      {{ msg_snackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState, mapGetters } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import Modal from "@/components/custom/Modal.vue";
export default {
  mixins: [apiCalls],
  components: {
    SGSNotificationConfirm, Modal
  },
  data() {
    return {
      errors: [],
      dialogNotification: false,
      importNotification: false,
      dialogNotificationDeleteScores: false,
      alertError: false,
      alertErrorMsg: '',
      dialog: false,
      editorType: 'new',
      titleModal: this.$tc('page.series.add-participant'),
      inputs: {
        races: -1,
        form: {
          participants: undefined,
          loadParticipant: undefined,
          id: '',
          userId: '-1',
          raceId: '',
          firstName: '',
          lastName: '',
          groupName: '',
          brand: '',
          className: '',
          overallPosition: '',
          classPosition: '',
          groupPosition: '',
          positionLabel: '',
          workerPoints: undefined,
          standing: ''
        }
      },
      items: {
        races: []
      },
      serieItem: {
        inf: null
      },
      filters: {},
      participants: [],
      selectedParticipant: undefined,
      column: [],
      listData: [],
      userCurrent: null,
      snackbar: false,
      color_snackbar: '',
      msg_snackbar: '',
      listWorkerPoints: [],
      participantsSeries: [],
      classSeries: [],
      groupSeries: [],
      isLoading: false,
      search: '',
      reloadTable: false,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      modalStartX: 0,
      modalStartY: 0,
      isOpen: false,
      isModalOpen: false
    }
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    ...mapGetters({
      races: 'getRacesList',
      results: 'getResultsList',
      resultsAll: 'getResultsListAll',
      raceSelected: 'getRaceSelected'
    }),
    itemsRaces() {
      let races = [];
      races.push({
        text: this.$t("page.series.table.race.all-races"),
        value: -1
      });
     return races.concat(races,this.races.map((race) => {
        return {
          text: `${this.$escapeHtml.decode(race.eventName)} :: ${this.$escapeHtml.decode(race.raceName)}`,
          value: race.raceId
        };
     }));
    },
    headers() {
      return [{
        text: this.$t("page.series.table.results.race-name"),
        value: "raceName",
        filter: f => {
          if (this.filters.racename == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.racename.toLowerCase())
        }
      },
      {
        text: this.$t("common.form.user-id"),
        value: "userId",
        filter: f => {
          if (this.filters.userid == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.userid.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.first-name"),
        value: "firstName",
        filter: f => {
          if (this.filters.firstname == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.firstname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.last-name"),
        value: "lastName",
        filter: f => {
          if (this.filters.lastname == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.lastname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.group-name"),
        value: "groupName",
        filter: f => {
          if (this.filters.groupname == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.groupname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.brand"),
        value: "brand",
        filter: f => {
          if (this.filters.brand == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.brand.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.class-name"),
        value: "className",
        filter: f => {
          if (this.filters.classname == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.classname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.overall-position"),
        value: "overallPosition",
        filter: f => {
          if (this.filters.overallposition == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.overallposition.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.class-position"),
        value: "classPosition",
        filter: f => {
          if (this.filters.classposition == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.classposition.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.group-position"),
        value: "groupPosition",
        filter: f => {
          if (this.filters.groupposition == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.groupposition.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.position-label"),
        value: "positionLabel",
        filter: f => {
          if (this.filters.positionlabel == undefined) {
            if (!f) {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.positionlabel.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.actions"),
        value: "actions"
      },
      ];
    },
    selectParticipants() {
      const response = [];
      const length = (this.participants || []).length

      for (var i = 0; i < length; i++) {
        response[i] = [];
        response[i].value = this.participants[i].id;
        response[i].participantIndex = i;
        response[i].text = `${this.participants[i].lastName}, ${this.participants[i].firstName} (${this.participants[i].raceClassName})`
      }

      return response;
    },
    groupNameRules: function () {
      return [v => !!v || this.$t("page.race-scores.group-name-required")];
    },
    brandRules: function () {
      return [v => !!v || this.$t("page.race-scores.brand-required")];
    },
    classNameRules: function () {
      return [v => !!v || this.$t("page.race-scores.class-name-required")];
    },
    raceIdRules: function () {
      return [v => v !== -1 || this.$t("page.race-scores.race-id-required")];
    },
    overallPositionRules: function () {
      return [v => (!v || (v && v.length <= 5)) || this.$t("page.race-scores.overall-position-max-lenght-5")];
    },
    classPositionRules: function () {
      return [v => (!v || (v && v.length <= 5)) || this.$t("page.race-scores.class-position-max-lenght-5")];
    },
    groupPositionRules: function () {
      return [v => (!v || (v && v.length <= 5)) || this.$t("page.race-scores.group-position-max-lenght-5")];
    },
    positionLabelRules: function () {
      return [v => !!v || this.$t("page.race-scores.position-label-required")];
    },
    standingItems() {
      return [
        { text: 'Scored', value: 'Scored' },
        { text: 'Worker', value: 'WORKER' },
        { text: 'DSQ', value: 'DSQ' },
        { text: 'DNF', value: 'DNF' },
        { text: 'SSA', value: 'SSA' },
        { text: 'DNS', value: 'DNS' }
      ];
    },
    standingRules() {
      return [v => !!v || this.$t("page.race-scores.standing-required")];
    },
    /**
     * The table function processes the results stored in `this.results` and
     * returns a formatted data structure for use in a table.
     *
     * @returns {Object} - An object containing the formatted data from the results.
     */
    table() {
      return {
        data: this.results.map((element) => {
          // Destructure the necessary properties from the `element` object
          const { 
            id, raceName, raceId, userId, firstName, lastName, groupName, brand, className, 
            classPosition, overallPosition, groupPosition, positionLabel, fkSeriesWorkerPointsSchemaId,
            standing, finalStanding
          } = element;

          // Determine the value of `standingShow` based on the specified conditions
          const standingShow = standing 
            ? (standing !== 'Scored' ? standing : '') 
            : (finalStanding ? (finalStanding !== 'Scored' ? finalStanding : '') : '');

          // Return a new object with the formatted properties and add `actions`
          return { 
            id, raceName, raceId, userId, firstName, lastName, groupName, brand, className, 
            classPosition, overallPosition, groupPosition, positionLabel, fkSeriesWorkerPointsSchemaId, 
            standingShow, standing, finalStanding, actions: "actions"
          };
        })
      };
    },
    /**
     * The classSeriesProcessed function processes the results stored in `this.results`
     * to create an array of unique class names.
     *
     * @returns {Array} - An array of objects, each containing a unique class name.
     */
    classSeriesProcessed() {
      // Create an array to store the processed items
      const processedItems = [];
      // Create a Set to keep track of unique class names
      const uniqueClassNames = new Set();
      // Iterate over the results once
      for (const item of this.classSeries) {
        const { className, groupName } = item;
        // Check if className is valid and not already in the Set
        if (className && !uniqueClassNames.has(className)) {
          uniqueClassNames.add(className);
          // Add the processed item to the array
          processedItems.push({ className, disabled: false, groupName: groupName });
        }
      }
      return processedItems;
    },
    tabulatorOptions() {
      return {
        placeholder: this.$t("common.table.no-data"),
        tooltips: true,
        addRowPos: "top",
        height: "600",
        layout: "fitColumns",
        resizableColumns: true,
        columns: [
          {
            title: this.$t("page.series.table.results.race-id"),
            field: "raceId",
            visible: true,
            sorter: "number",
            width: "70",
            widthShrink: 1,
            cssClass: "srs-col-horizontal",
            headerFilter: "input",
            headerFilterPlaceholder: " "
          },
          {
            title: this.$t("page.series.table.results.race-name"),
            field: "raceName",
            visible: true,
            widthGrow: 3,
            widthShrink: 3,
            cssClass: "srs-col-horizontal srs-col-nowrap",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            formatter: "textarea"
          },
          {
            title: this.$t("common.form.user-id"),
            field: "userId",
            visible: true,
            sorter: 'number',
            width: "70",
            widthShrink: 1,
            widthGrow: 1,
            cssClass: "srs-col-horizontal",
            headerFilter: "input",
            headerFilterPlaceholder: " "
          },
          {
            title: this.$t("page.series.table.results.first-name"),
            field: "firstName",
            visible: true,
            width: "90",
            widthGrow: 1,
            cssClass: "srs-col-horizontal srs-col-wrap",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            formatter: "textarea"
          },
          {
            title: this.$t("page.series.table.results.last-name"),
            field: "lastName",
            visible: true,
            width: "90",
            widthGrow: 1,
            cssClass: "srs-col-horizontal srs-col-wrap",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            formatter: "textarea"
          },
          {
            title: this.$t("page.series.table.results.group-name"),
            field: "groupName",
            visible: true,
            widthGrow: 1,
            cssClass: "srs-col-horizontal srs-col-wrap",
            headerFilterPlaceholder: " ",
            headerFilter: 'select',
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true }
          },
          {
            title: this.$t("page.series.table.results.brand"),
            field: "brand",
            visible: true,
            width: "80",
            widthGrow: 1,
            cssClass: "srs-col-horizontal",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            formatter: "textarea"
          },
          {
            title: this.$t("page.series.table.results.class-name"),
            field: "className",
            visible: true,
            width: "100",
            widthGrow: 2,
            cssClass: "srs-col-horizontal srs-col-wrap",
            headerFilterPlaceholder: " ",
            headerFilter: 'select',
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            formatter: "textarea"
          },
          {
            title: this.$t("page.series.table.results.standing"),
            field: "standingShow",
            visible: true,
            sorter: "string",
            width: "55",
            widthShrink: 1,
            cssClass: "srs-col-vertical",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            formatter: "textarea"
          },
          {
            title: this.$t("page.series.table.results.overall-position"),
            field: "overallPosition",
            visible: true,
            sorter: 'number',
            sorterParams: {
              alignEmptyValues: "bottom"
            },
            width: "55",
            widthShrink: 1,
            cssClass: "srs-col-vertical",
            headerFilter: "input",
            headerFilterPlaceholder: " "
          },
          {
            title: this.$t("page.series.table.results.class-position"),
            field: "classPosition",
            visible: true,
            sorter: 'number',
            sorterParams: {
              alignEmptyValues: "bottom"
            },
            width: "55",
            widthShrink: 1,
            cssClass: "srs-col-vertical",
            headerFilter: "input",
            headerFilterPlaceholder: " "
          },
          {
            title: this.$t("page.series.table.results.group-position"),
            field: "groupPosition",
            visible: true,
            sorter: 'number',
            sorterParams: {
              alignEmptyValues: "bottom"
            },
            width: "55",
            widthShrink: 1,
            cssClass: "srs-col-vertical",
            headerFilter: "input",
            headerFilterPlaceholder: " "
          },
          {
            title: this.$t("page.series.table.results.position-label"),
            field: "positionLabel",
            visible: true,
            width: "55",
            widthShrink: 1,
            sorter: 'string',
            sorterParams: {
              alignEmptyValues: "bottom"
            },
            cssClass: "srs-col-vertical",
            headerFilter: "input",
            headerFilterPlaceholder: " "
          },
          {
            title: this.$t("page.series.table.results.actions"),
            field: "actions",
            visible: true,
            width: "100",
            widthShrink: 1,
            columns: [
              {
                title: "",
                field: "edit",
                width: "40",
                widthShrink: 1,
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-edit'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  const data = cell.getData();
                  this.editItem(data);
                }.bind(this),
              },
              {
                title: "",
                field: "delete",
                width: "40",
                widthShrink: 1,
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-trash'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  const data = cell.getData();
                  this.confirmDelete(data);
                }.bind(this),
              },
            ],
          }
        ]
      };
    },
    column_items() {
      return [
        {
          id: 0,
          text: this.$t("page.series.table.results.race-id"),
          field: "raceId"
        },
        {
          id: 1,
          text: this.$t("page.series.table.results.race-name"),
          field: "raceName"
        },
        {
          id: 2,
          text: this.$t("common.form.user-id"),
          field: "userId"
        },
        {
          id: 3,
          text: this.$t("page.series.table.results.first-name"),
          field: "firstName"
        },
        {
          id: 4,
          text: this.$t("page.series.table.results.last-name"),
          field: "lastName"
        },
        {
          id: 5,
          text: this.$t("page.series.table.results.group-name"),
          field: "groupName"
        },
        {
          id: 6,
          text: this.$t("page.series.table.results.brand"),
          field: "brand"
        },
        {
          id: 7,
          text: this.$t("page.series.table.results.class-name"),
          field: "className"
        },
        {
          id: 8,
          text: this.$t("page.series.table.results.standing"),
          field: "standing"
        },
        {
          id: 9,
          text: this.$t("page.series.table.results.overall-position"),
          field: "overallPosition"
        },
        {
          id: 10,
          text: this.$t("page.series.table.results.class-position"),
          field: "classPosition"
        },
        {
          id: 11,
          text: this.$t("page.series.table.results.group-position"),
          field: "groupPosition"
        },
        {
          id: 12,
          text: this.$t("page.series.table.results.position-label"),
          field: "positionLabel",
        },
        {
          id: 13,
          text: this.$t("page.series.table.results.actions"),
          field: "actions"
        }
      ];
    }
  },
  created() {
    this.getRaceList();
    this.getResults();
  },
  mounted() {
    this.loadColumns();
    this.getWorkerPoints();
    this.$store.commit('setBSeriesResults', true);
  },
  methods: {
    onParticipantSelected(val) {
      // Find the selected item in participantsSeries based on the value
      const selectedItem = this.participantsSeries.find(item => item.value === val);
      
      if (selectedItem) {
        // Update the text of the selected item
        selectedItem.text = selectedItem.text1;
        this.form 
      }
    },
    containsHTML(text) {
        // Check for common HTML tags
        const simpleHTMLRegex = /<[^>]*>/;
        if (simpleHTMLRegex.test(text)) return true;
        // Use DOMParser for additional verification
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        return doc.body.children.length > 0;
    },
    openModal() {
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
    },
    startDrag(event) {
      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      const modal = this.$refs.modal;
      this.modalStartX = modal.offsetLeft;
      this.modalStartY = modal.offsetTop;
    },
    removeHTML(text, options = {}) {
        const {
            removeEntities = true,
            normalizeSpaces = true,
            preserveNewlines = false
        } = options;

        // Remove HTML tags
        let cleanText = text.replace(/<[^>]*>/g, preserveNewlines ? '\n' : ' ');

        // Remove HTML entities if configured
        if (removeEntities) {
            cleanText = cleanText.replace(/&[^;]+;/g, ' ');
        }

        // Normalize spaces if configured 
        if (normalizeSpaces) {
            cleanText = cleanText.replace(/\s+/g, ' ').trim();
        }

        return cleanText;
    },
    paintMatchingTerms(str, search) {
      if (!search || typeof search != 'string') return search;

      const terms = search.split(' ').filter(obj => obj);
      if (!terms || terms.length === 0) {
        return str;
      }

      let response = str;
      let expReg = terms.map((term) => {
        return term.replaceAll("\\", "\\\\")
          .replaceAll("(", "\\(")
          .replaceAll(")", "\\)")
          .replaceAll(".", "\\.")
          .replaceAll("*", "\\*")
          .replaceAll("+", "\\+")
          .replaceAll("?", "\\?")
          .replaceAll("^", "\\^")
          .replaceAll("$", "\\$")
          .replaceAll("[", "\\]")
          .replaceAll("]", "\\]")
          .replaceAll("}", "\\}")
          .replaceAll("{", "\\{")
          .replaceAll("|", "\\|");
      }).join('|');

      let regex = new RegExp(expReg, "gi");
      response = str.replaceAll(regex, function (value) { return `<span style="color: #808080;">${value}</span>`; });

      return response;
    },
    /**
         * Custom filter method to perform case-insensitive search on the 'text' property of the provided 'item' object
         * using a query text with special character handling.
         *
         * @param {Object} item - The object to be filtered, typically containing a 'text' property.
         * @param {string} queryText - The query text to search for within the 'text' property of the 'item'.
         * @returns {boolean} - Returns true if the 'text' property of 'item' contains the query text, false otherwise.
         */
    customFilter(item, queryText) {
      const arraySearch = queryText.toLowerCase().replaceAll("\\", "\\\\")
        .replaceAll("(", "\\(")
        .replaceAll(")", "\\)")
        .replaceAll(".", "\\.")
        .replaceAll("*", "\\*")
        .replaceAll("+", "\\+")
        .replaceAll("?", "\\?")
        .replaceAll("^", "\\^")
        .replaceAll("$", "\\$")
        .replaceAll("[", "\\]")
        .replaceAll("]", "\\]")
        .replaceAll("}", "\\}")
        .replaceAll("{", "\\{")
        .replaceAll("|", "\\|").split(' ');
      const regex = new RegExp(arraySearch.join('|'));

      return item.search.toLowerCase().search(regex) > -1
    },
    /**
     * Function to recover the last search terms and update the 'search' property.
     * This function directly assigns the value of 'lastSearch' to the 'search' property.
     * If 'lastSearch' has a value (not null or undefined), 'search' takes that value.
    * If 'lastSearch' is null or undefined, 'search' is set to an empty string.
    */
    recoverLastSearchTerms() {
      this.search = this.lastSearch ?? '';
    },
    /**
     * Handles the search cache by storing user input and updating the last search.
     * Only user-entered data is cached in this method.
     *
     * @param {string} search - The user's input to be stored in the search cache.
     */
    searchCacheHandler(search) {
      if (search) {
        // Cache the first character of the search input if lastSearch is not set
        if (search.length === 1 && !this.lastSearch) {
          this.lastSearch = search;
        }

        // Update lastSearch if the length of the current search is one less than the previous one
        if (this.lastSearch && this.lastSearch.length === search.length - 1) {
          this.lastSearch = search;
        }

        // Update lastSearch if the length of the current search is one more than the previous one
        if (this.lastSearch && this.lastSearch.length === search.length + 1) {
          this.lastSearch = search;
        }
      }

      // Reset lastSearch if the current search is empty and the previous one had a length of one
      if (!search && this.lastSearch && this.lastSearch.length === 1) {
        this.lastSearch = search;
      }
    },
    columnSelection() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();

      for (var i = 0; i < this.column_items.length; i++) {

        var findColumn = this.column.find(
          element => element == i
        );

        if (findColumn != undefined) {
          tabulatorInstance.showColumn(this.column_items[i].field);
        } else {
          tabulatorInstance.hideColumn(this.column_items[i].field);
        }
        tabulatorInstance.redraw();
      }
    },
    loadColumns() {

      this.column = [
        {
          id: 0,
          text: this.$t("page.series.table.results.race-id"),
          field: "raceId"
        },
        {
          id: 1,
          text: this.$t("page.series.table.results.race-name"),
          field: "raceName"
        },
        {
          id: 2,
          text: this.$t("common.form.user-id"),
          field: "userId"
        },
        {
          id: 3,
          text: this.$t("page.series.table.results.first-name"),
          field: "firstName"
        },
        {
          id: 4,
          text: this.$t("page.series.table.results.last-name"),
          field: "lastName"
        },
        {
          id: 5,
          text: this.$t("page.series.table.results.group-name"),
          field: "groupName"
        },
        {
          id: 6,
          text: this.$t("page.series.table.results.brand"),
          field: "brand"
        },
        {
          id: 7,
          text: this.$t("page.series.table.results.class-name"),
          field: "className"
        },
        {
          id: 8,
          text: this.$t("page.series.table.results.standing"),
          field: "standing"
        },
        {
          id: 9,
          text: this.$t("page.series.table.results.overall-position"),
          field: "overallPosition"
        },
        {
          id: 10,
          text: this.$t("page.series.table.results.class-position"),
          field: "classPosition"
        },
        {
          id: 11,
          text: this.$t("page.series.table.results.group-position"),
          field: "groupPosition"
        },
        {
          id: 12,
          text: this.$t("page.series.table.results.position-label"),
          field: "positionLabel",
        },
        {
          id: 13,
          text: this.$t("page.series.table.results.actions"),
          field: "actions"
        }
      ];
    },
    async updateParticipantForm() {
      const index = this.inputs.form.participantIndex;
      this.inputs.form.userId = this.inputs.form.participants.value;
      this.inputs.form.firstName = this.participants[index].firstName
      this.inputs.form.lastName = this.participants[index].lastName
      this.inputs.form.className = this.participants[index].raceClassName
      this.inputs.form.brand = this.participants[index].brand
      this.inputs.form.raceId = this.inputs.races
    },
    resetFilters() {
      for (const [key] of Object.entries(this.filters)) {
        //this will loop over all active filters only, others are undefined
        this.filters[key] = undefined
      }
    },
    async getRaceList() {
      if (this.seriesSelected) {
        let responseClass = await this.api("get", `/api/v1/promoter/series/${this.seriesSelected.id}/class`);
        let responseGroup = await this.api("get", `/api/v1/promoter/series/group/${this.seriesSelected.id}`);

        if (responseClass.success) {
          this.classSeries = responseClass.message.data;
        } else {
          this.classSeries = [];
        }

        if (responseGroup.success) {
          this.groupSeries = [{ groupName: this.$t('common.form.no-group') }];
          this.groupSeries = this.groupSeries.concat(responseGroup.message.data);
        } else {
          this.groupSeries = [];
        }
        this.$store.dispatch('getRacesListAction', this.seriesSelected.id);
      }
    },
    async getResults() {
      if (this.seriesSelected)
      {
        const raceId = this.inputs.races;
        
        // Set race selection in the store
        this.$store.commit('setRaceSelected', raceId);
        
        // Dispatch an action to get the results
        await this.$store.dispatch('getResultsAction', {
          seriesId: this.seriesSelected.id,
          raceId
        });
        
        await this.$store.dispatch('getResultsAllAction', this.seriesSelected.id);

        // Build the correct URL based on the raceId
      }
    },
    /*async getResultsErrorMerge() {
      if (this.seriesSelected) {
        const raceId = this.inputs.races;
        this.$store.commit('setRaceSelected',raceId);
        this.$store.dispatch('getResultsAction', { seriesId: this.seriesSelected.id, raceId });
        const url =
          raceId == -1
            ? `/api/v1/promoter/series/${this.seriesSelected.id}/results`
            : `/api/v1/promoter/series/${this.seriesSelected.id}/race/${raceId}/results`;

        // Fetch data from the API
        try {
          const response = await this.api("get", url);
          
          if (response && response.message && response.message.data) {
            // Clear existing table data
            this.table.data = [];
            
            // Iterate through the response data
            response.message.data.forEach(element => {
              const row = {
                id: element.id,
                raceName: element.raceName,
                raceId: element.raceId,
                userId: element.userId,
                firstName: element.firstName,
                lastName: element.lastName,
                groupName: element.groupName,
                brand: element.brand,
                className: element.className,
                classPosition: element.classPosition,
                overallPosition: element.overallPosition,
                groupPosition: element.groupPosition,
                positionLabel: element.positionLabel,
                workerPoints: element.fkSeriesWorkerPointsSchemaId,
                standingShow: element.finalStanding 
                  ? (element.finalStanding != 'Scored' ? element.finalStanding : '') 
                  : (element.standing ? (element.standing != 'Scored' ? element.standing : '') : ''),
                standing: element.standing,
                finalStanding: element.finalStanding,
                actions: "actions"
              };
              
              // Check if class exists in classSeries, if not, add it
              const classSelect = this.classSeries.find(el => el.className == element.className);
              if (!classSelect && (element.className || "").length > 0) {
                this.classSeries.push({
                  className: element.className,
                  disabled: true
                });
              }
              
              // Push the row into the table's data array
              this.table.data.push(row);
            });
          }
        } catch (error) {
          this.errors.push(error);
        }
      }
    },*/
    editItem(item) {
      this.inputs.form.id = item.id;
      this.inputs.form.userId = item.userId;
      this.inputs.form.raceId = item.raceId;
      this.inputs.form.firstName = item.firstName;
      this.inputs.form.lastName = item.lastName;
      const groupSelect = this.groupSeries.find((el) => { return el.groupName == item.groupName && el.groupName != this.$t('common.form.no-group'); });
      this.inputs.form.groupName = groupSelect ? groupSelect : null;
      this.inputs.form.brand = item.brand;
      this.inputs.form.overallPosition = item.overallPosition;
      this.inputs.form.classPosition = item.classPosition;
      this.inputs.form.groupPosition = item.groupPosition;
      this.inputs.form.positionLabel = item.positionLabel;
      this.inputs.form.workerPoints = item.fkSeriesWorkerPointsSchemaId;
      this.inputs.form.standing = item.finalStanding ? item.finalStanding : (item.standing ? item.standing : 'Scored');
      this.editorType = 'edit';
      this.dialog = true;
      this.titleModal = this.$t('page.series.edit-participant', {
        firstName: item.firstName || '',
        lastName: item.lastName || ''
      });

      const groupName = item.groupName ? item.groupName : '';
      const className = item.className ? item.className : '';

      const classSelected = this.classSeries.find(el =>
        (el.className || "").trim().toLowerCase() === (className || "").trim().toLowerCase()
      ) || null;

      this.$nextTick(() => {
        this.$set(this.inputs.form, 'className', classSelected);
      });

      setTimeout(() => {
        const groupSelected = this.groupSeries.find(el =>
          (el.groupName || "").trim().toLowerCase() === (groupName || "").trim().toLowerCase()
        ) || null;
        this.$set(this.inputs.form, 'groupName', groupSelected);
      }, 1000);

      this.isModalOpen = true;
    },
    createItem() {
      this.editorType = 'new';
      this.titleModal = this.$tc('page.series.add-participant')
      if (this.$refs.formEdit)
        this.$refs.formEdit.resetValidation();
      this.dialog = true;
      this.isModalOpen = true;
      this.inputs.form.id = undefined;
      this.inputs.form.userId = undefined;
      this.inputs.form.raceId = this.inputs.races;
      this.inputs.form.firstName = undefined;
      this.inputs.form.lastName = undefined;
      this.inputs.form.groupName = undefined;
      this.inputs.form.brand = undefined;
      this.inputs.form.className = undefined;
      this.inputs.form.overallPosition = undefined;
      this.inputs.form.classPosition = undefined;
      this.inputs.form.groupPosition = undefined;
      this.inputs.form.positionLabel = undefined;
      this.inputs.form.workerPoints = undefined;
      this.inputs.form.loadParticipant = undefined;
      this.inputs.form.standing = 'Scored';
    },
    async save() {
      if (this.$refs.formEdit.validate()) {
        let data = this.inputs.form;
        data.className = this.inputs.form.className ? this.inputs.form.className.className : null;
      
        data.groupName = (this.inputs.form.groupName && this.inputs.form.groupName.id) ? this.inputs.form.groupName.groupName : null;
        if(this.editorType != 'edit'){
          data.isManual = 1;
        }
    
        let url = '/api/v1/promoter/series/results/';
        url = this.editorType == 'edit' ? `${url}${data.id}` : url;

        const method = this.editorType == 'edit' ? 'PUT' : 'POST';
        const response = await this.api(method, url, data);

        if(response == undefined || response.error)
        {
          this.alertErrorMsg = this.$t(`page.series.errors.${response.error[0]}`);
          this.alertError = true;
        }
        this.close();
        this.getResults(true)
        await this.$store.dispatch('getResultsAllAction', this.seriesSelected.id);
        this.isModalOpen = false;
      }
    },
    close() {
      this.dialog = false;
      this.dialogNotification = false;
      this.isOpen = false;
      this.isModalOpen = false;
    },
    confirmDelete(item) {
      this.dialogNotification = true
      this.item = item
    },
    confirmDeleteScores() {
      this.dialogNotificationDeleteScores = true
    },
    importScoresConfirm() {
      this.importNotification = true
    },
    async deleteItem() {

      const response = await this.api('DELETE', `/api/v1/promoter/series/results/${this.item.id}`);
      if (response != undefined) {
        this.getResults(true)
        this.close();
      } else {
        this.close();
        this.alertErrorMsg = this.$t('common.error-delete');
        this.alertError = true;
      }
    },
    /**
     * Deletes the scores for the selected race(s) and handles different modes of deletion.
     * If the race is created from the series interface (modes 0, 6, 9, 10, 11), it will proceed to delete the series.
     * If `bandRaceList` is true and the deletion fails, it will refresh the results table.
     *
     * @param {boolean} bandRaceList - A flag to indicate whether to refresh the race list if deletion fails.
     */
    async deleteScores(bandRaceList = false) {
      try {
        this.dialogNotificationDeleteScores = false;
        // Attempt to delete the race(s) by sending a POST request with the race ID(s)
        const result = await this.api("post", "/api/v1/promoter/race", { force: true, raceId: this.inputs.races });

        if (!result.success) {
          if (bandRaceList) {
            this.reloadTable = false;
            this.getResults(); // Refresh the results table if deletion fails
          }
          return; // Exit early if the deletion was not successful
        }

        // Check if the mode is NOT valid and return early if it's invalid
        const validModes = [0, 3, 6, 9, 10, 11];
        if (!validModes.includes(result.message.mode)) {
          this.showSnackbar('error', this.$t('page.series.invalid_mode'));
          return; // Exit early for invalid mode
        }

        // Ensure the current user information is loaded
        if (!this.userCurrent) {
          const getUserCurrent = await this.api("get", "/api/v1/users/current");
          this.userCurrent = getUserCurrent.message;
        }

        // Attempt to delete the series
        try {
          await this.api("delete", "/api/v1/promoter/series/delete/" + this.inputs.races);
          this.showSnackbar('success', this.$t('common.success'));
          this.refreshScores();
        } catch (error) {
          this.showSnackbar('error', this.$t('page.series.failed_delete'));
        }

      } catch (error) {
        this.showSnackbar('error', this.$t('page.series.failed_delete'));
      }
    },

    /**
     * Displays a snackbar message with a specified color.
     *
     * @param {string} color - The color of the snackbar (e.g., 'success', 'error').
     * @param {string} message - The message to display in the snackbar.
     */
    showSnackbar(color, message) {
      this.msg_snackbar = message;
      this.color_snackbar = color;
      this.snackbar = true;
    },

    async importScores(bandRaceList = false) {
      const result = await this.api(
        "post",
        "/api/v1/promoter/race",
        { force: true, raceId: this.inputs.races });
      if (result.success) {
        //mode 0 and 3 is for races created from series interface
        if ([11, 10, 9, 6, 3, 0].includes(result.message.mode)) {
          if (!this.userCurrent) {
            const getUserCurrent = await this.api("get", "/api/v1/users/current");
            this.userCurrent = getUserCurrent.message;
          }
          const importResult = await this.api(
            "get",
            "/api/v1/promoter/series/import/" + this.inputs.races
          );
          const importSucceeded = importResult && (
            importResult.success === true ||
            importResult.success === 1 ||
            importResult.status === 'queued'
          );

          if (importSucceeded) {
            this.msg_snackbar = this.$t('common.success');
            this.color_snackbar = 'success';
            this.snackbar = true;
            this.refreshScores();
            this.importNotification = false;
          } else {
            this.msg_snackbar = this.$t('page.series.failed_import');
            this.color_snackbar = 'error';
            this.snackbar = true;
            this.importNotification = false;
          }
        } else {
          this.msg_snackbar = this.$t('page.series.invalid_mode');
          this.color_snackbar = 'error';
          this.snackbar = true;
          this.importNotification = false;
        }
      } else if (bandRaceList) {
        this.reloadTable = false;
        this.getResults();
        this.importNotification = false;
      }
    },
    refreshScores() {
      this.getRaceList();
      this.reloadTable = false;
      this.getResults();
    },
    async getWorkerPoints() {
      if (this.seriesSelected) {
        const response = await this.api(
          "get",
          "/api/v1/promoter/series/getWorkerPoints/" + this.seriesSelected.id);
        if (response.success) {
          this.listWorkerPoints = response.message.map((el) => {
            return { value: el.id, text: `${el.workerPointsSchemaName} (${el.workerPointsSchemaDescription})` }
          });
        }
      }
    },
    processTableData(newVal) {
      return newVal.map((el) => {
        return {
          ...el,
          raceName: this.$escapeHtml.decode(el.raceName),
          className: (el.className || "").trim(),
          groupName: (el.groupName || "").trim(),
          standingShow:  el.finalStanding
        };
      });
    }
  },
  watch: {
    async search(val) {

      // Sanitize value by removing any HTML
      if (val && this.containsHTML(val)) {
        // Remove HTML and update value
        this.$nextTick(() => {
          this.search = this.removeHTML(val);
        });
        return;
      }
      
      this.searchCacheHandler(val);

      if ((val || "").length >= 3) {
        if (this.isLoading) return
        this.isLoading = true;

        if (this.seriesSelected) {
          val = val.replace(/<span class='partid'>.*?<\/span>/, '');
          const url = `/api/v1/promoter/series/${this.seriesSelected.id}/results/participants/${val}`;
          const response = await this.api("get", url);

          if (response.success)
          {

           const data = response.message;

            const updatedData = data.map(item => {
              // Return a new object, copying all original properties and adding the additionalInfo field
              return {
                ...item, // Copy all original properties of the object
                additionalInfo: [] // Add the additionalInfo field as an empty array
              };
            });

            this.participants = updatedData;

            this.participantsSeries = updatedData
            .map((el) => {
              let text = `<span class='partid'>${el.id}</span>${el.lastName}, ${el.firstName}`;
              let text1 = `${el.id}, ${el.lastName}, ${el.firstName}`;

              if(el.age){
                text += `, Age: ${el.age} \n`;
                text1 += `, Age: ${el.age} \n`;
              }

              if(el.state){
                text += `, ${el.state}`;
                text1 += `, ${el.state}`;
              }

              if(el.country){
                text += `, ${el.country}`;
                text1 += `, ${el.country}`;
              }

              if(el.phone){
                text += `, ${el.phone}`
                text1 += `, ${el.phone}`
              }

              if(el.address){
                text += `, ${el.address}`
                text1 += `, ${el.address}`
              }

              if(el.clubName){
                const membership = {
                  clubName: el.clubName,
                  raceClass: el.raceClass,
                  organizationClass: el.organizationClass
                }
                el.additionalInfo.push(membership)
              }

              return {
                value: el.id,
                text: text,
                text1: text1,
                additionalInfo: el.additionalInfo,
                search: `${el.lastName}, ${el.firstName}`
              };
            })
          }
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
        this.participantsSeries = [];
      }
    },
    seriesSelected() {
      this.getRaceList();
      this.getResults();
      this.getWorkerPoints();
      this.inputs.races = -1;
    },
    'inputs.form.loadParticipant': {
      handler: function (after) {
        
        const part = this.participants.find((el) => {
          return el.id == after;
        });
        if (part) {
          const _data = this.resultsAll;
          const _dd = _data
            .filter(x => x.userId === part.userId)
            .sort((a, b) => b.id - a.id);

          this.inputs.form.brand = _dd.length > 0 ? _dd[0].brand : part.brand;

          const groupName = _dd.length > 0 ? _dd[0].groupName : '';
          const className = _dd.length > 0 ? _dd[0].className : '';

          const groupSelected = this.groupSeries.find(el =>
            (el.groupName || "").trim().toLowerCase() === (groupName || "").trim().toLowerCase()
          ) || null;

          const classSelected = this.classSeries.find(el =>
            (el.className || "").trim().toLowerCase() === (className || "").trim().toLowerCase()
          ) || null;

          this.$nextTick(() => {
            this.$set(this.inputs.form, 'className', classSelected);
            this.$set(this.inputs.form, 'groupName', groupSelected);
          });

          Object.assign(this.inputs.form, {
            firstName: part.firstName,
            lastName: part.lastName,
            userId: part.userId,
          });
        }
      },
      deep: true
    }
    ,
    'inputs.form.className': {
      handler: function (after) {
        let groupSelected = null;
        if (after) {
          groupSelected = this.groupSeries.find((el) => {
            return (el.groupName || "").trim().toLowerCase() == (after.groupName || "").trim().toLowerCase();
          });
        }
        this.inputs.form.groupName = groupSelected ? groupSelected : (after ? { groupName: this.$t('common.form.no-group') } : undefined);
      },
      deep: true
    },
    table: {
      handler(newVal) {
        if(!this.reloadTable) {
          this.listData = this.processTableData(newVal.data);
          this.reloadTable = true;
        } else {
           this.$refs.tabulator.getInstance().replaceData(this.processTableData(newVal.data));
           this.listData = this.processTableData(newVal.data);
        }
      },
      deep: true
    },
    raceSelected(val) {
      this.inputs.races = val;
    },
  }
};
</script>

<style>
.group-resp {
  display: block;
}

.group-resp .v-btn {
  min-height: 36px;
  white-space: normal;
  max-width: 100%;
  float: left;
  display: block;
}

.orlbl {
  font-weight: bold;
  font-size: 14px;
  margin-right: 20px;
}

.newseriesbtn {
  margin-top: 0px !important;
}

.srs_fset {
  padding: 0.35em 0.625em 0.75em !important;
  margin: 5px !important;
  border: 1px solid var(--v-lighten-base) !important;
}

.srs_lgd {
  width: auto !important;
  font-size: 15px !important;
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

.customlink {
  color: var(--v-primary-lighten1);
  font-weight: bold;
  text-decoration: underline;
}

.tabscard {
  margin: 10px 5px;
}

.v-tab {
  text-transform: initial;
}

.text-start {
  vertical-align: baseline;
}

.formEdit .v-text-field__details,
.formEdit .v-messages {
  min-height: 0;
  display: flex !important;
}

.formEdit .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,
.formEdit .v-select__slot {
  min-height: 32px;
  height: 34px;
}

.formEdit .col-12 {
  padding: 6px 12px;
}

.formEdit .v-text-field--outlined.v-input--dense .v-label {
  top: 7px;
}

.filtersSeries .v-text-field__details,
.filtersSeries .v-messages {
  display: none;
}

.filtersSeries .v-input {
  font-size: 14px;
}

.filtersSeries .v-chip.v-size--default {
  height: 26px;
  font-size: 12px;
}
.dd-dialog {
  position: absolute;
  cursor: move;
}
.partid{
  color: black;
  font-size: 0.8em;
  display: block;
}

.tabulator .tabulator-header {
  background: #495464 !important;
}

.tabulator .tabulator-header .tabulator-col {
  background-color: #495464 !important;
  color: white;
  border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content {
  font-size: 13px !important;
  padding: 4px !important;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-title {
  white-space: normal !important;
  line-height: 1.3;
  text-align: center;
  padding-bottom: 4px;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter {
  width: 100%;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
  border: 1px solid #aaa;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}

.tabulator .tabulator-header .tabulator-col-group {
  border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.tabulator .tabulator-header .tabulator-col-group-cols {
  border-top: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.srs-col-wrap .tabulator-col-title {
  word-break: break-word;
}

.srs-col-nowrap .tabulator-col-title {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.srs-col-vertical .tabulator-col-title {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap !important;
  font-size: 13px !important;
  line-height: 1.2;
  margin: 0 auto;
  padding: 6px 2px;
}

.srs-col-vertical .tabulator-arrow {
  display: none !important;
}
</style>
